import React, { useState } from "react";
import { Table, Container, Col } from "react-bootstrap";
import { FaFilePdf, FaHome, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import RelatorioForm from "./gerarGarantia";
import RelatorioPage from "../../pages/garantiaRelatório/relatorioPage";
import dataFormatada from "../../hooks/Date/dataFormatada";

const RelatorioGarantia = ({ filtro, dataHora, dados, setShowForm, setShowRelatorio }) => {
  //console.log(dados);
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/home");
  };

  const handleForm = () => {
    setShowForm(true);
    setShowRelatorio(false);
  };

  const gerarPDF = () => {
    const titulo = {
      text: "Empresa: " + filtro.nomeEmpresa,
      fontSize: 20,
      bold: true,
      margin: [0, 0, 0, 10], // Margem inferior aumentada
    };

    const dadosRelatorio = {
      text: [
        { text: "Unidade: ", bold: true }, // Texto em negrito
        filtro.nomeUnidade || "Todas as unidades de " + filtro.nomeEmpresa,
        "\n",
        { text: "Tipo de Aplicação: ", bold: true },
        filtro.tipoAplicacao || "Todos",
        "\n",
        { text: "Garantia: ", bold: true },
        filtro.garantia || "Em garantia e garantia expirada",
        "\n",
        { text: "Gerado em: ", bold: true }, // Texto em negrito
        dataHora,
      ],
      margin: [0, 0, 0, 20], // Margem inferior aumentada
    };

    const estiloCabecalho = {
      fontSize: 18,
      bold: true,
      // margin: [0, 0, 0, 20], // Margem inferior aumentada
    };

    const cardStyle = {
      margin: [0, 20],
      border: "1px solid #ccc",
      borderRadius: 10,
      padding: 10,
    };

    const tabelaAplicacoesEmGarantia = {
      table: {
        headerRows: 1,
        widths: ["auto", "auto", "auto", "auto"],
        body: [
          [
            { text: "Unidade", style: "tableHeader" },
            { text: "Tipo de Aplicação", style: "tableHeader" },
            { text: "Descrição da Aplicação", style: "tableHeader" },
            { text: "Fim da Garantia", style: "tableHeader" },
          ],
          ...dados.data.relatorio.unidades.flatMap((unidade) =>
            unidade.aplicacoes_em_garantia.map((aplicacao) => [
              unidade.nome,
              aplicacao.tipo_aplicacao.descricao,
              aplicacao.descricao,
              dataFormatada(aplicacao.data_garantia),
            ])
          ),
        ],
      },
      layout: "lightHorizontalLines",
      style: "tableMargin",
    };

    const tabelaAplicacoesSemGarantia = {
      table: {
        headerRows: 1,
        widths: ["auto", "auto", "auto", "auto"],
        body: [
          [
            { text: "Unidade", style: "tableHeader" },
            { text: "Tipo de Aplicação", style: "tableHeader" },
            { text: "Descrição da Aplicação", style: "tableHeader" },
            { text: "Fim da Garantia", style: "tableHeader" },
          ],
          ...dados.data.relatorio.unidades.flatMap((unidade) =>
            unidade.aplicacoes_sem_garantia.map((aplicacao) => [
              unidade.nome,
              aplicacao.tipo_aplicacao.descricao,
              aplicacao.descricao,
              dataFormatada(aplicacao.data_garantia),
            ])
          ),
        ],
      },
      layout: "lightHorizontalLines",
      style: "tableMargin",
    };

    const docDefinition = {
      content: [
        {
          stack: [
            titulo,
            {
              columns: [{ width: "auto", text: dadosRelatorio.text }],
            },
          ],
        },
        filtro.garantia === "Em garantia" || !filtro.garantia
          ? {
              stack: [
                { text: "Em garantia", style: estiloCabecalho },
                tabelaAplicacoesEmGarantia,
              ],
              style: cardStyle,
            }
          : null,
        filtro.garantia === "Sem garantia" || !filtro.garantia
          ? {
              stack: [
                { text: "Garantia expirada", style: estiloCabecalho },
                tabelaAplicacoesSemGarantia,
              ],
              style: cardStyle,
            }
          : null,
      ],
      styles: {
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: "black",
        },
        tableMargin: {
          margin: [0, 0, 0, 10],
        },
        header: estiloCabecalho, // Aplicando estilo ao cabeçalho
      },
    };

    pdfMake
      .createPdf(docDefinition)
      .download("relatorio_aplicacoes_garantia.pdf");
  };

  return (
    <Container align="left" className="mt-4 d-flex">
      <button
        onClick={gerarPDF}
        style={{
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 9999,
          backgroundColor: "#DF2E38",
          padding: 20,
          borderRadius: 40,
          border: "none",
          cursor: "pointer",
        }}
      >
        <FaFilePdf size={25} color="white" /> {/* Ícone de PDF */}
      </button>
      <button
        onClick={handleForm}
        style={{
          position: "fixed",
          bottom: 20,
          right: 90,
          zIndex: 9999,
          backgroundColor: "#41B06E",
          padding: 20,
          borderRadius: 40,
          border: "none",
          cursor: "pointer",
        }}
      >
        <FaPlus size={25} color="white" /> {/* Ícone de PDF */}
      </button>
      <button
        onClick={handleGoHome}
        style={{
          position: "fixed",
          bottom: 20,
          right: 160,
          zIndex: 9999,
          backgroundColor: "#B4B4B8",
          padding: 20,
          borderRadius: 40,
          border: "none",
          cursor: "pointer",
        }}
      >
        <FaHome size={25} color="white" /> {/* Ícone de PDF */}
      </button>

      <div className="border">
        <div>
          <Col className="border">
            <h3>Empresa: {filtro.nomeEmpresa}</h3>
          </Col>
        </div>
        <div className="">
          <Col className="border">
            <ul className="list-unstyled">
              <li>
                <strong>Unidade: </strong>
                {filtro.nomeUnidade ||
                  `Todas as unidades de ${filtro.nomeEmpresa}`}
              </li>
              <li>
                <strong>Tipo de Aplicação: </strong>
                {filtro.descricaoTipoAplicacao || "Todos"}
              </li>
              <li>
                <strong>Garantia: </strong>
                {filtro.garantia || "Em garantia e garantia expirada"}
              </li>
            </ul>
          </Col>
        </div>
        <div>
          <Col className="border">
            <p>
              <strong>Data e Hora do Relatório:</strong> {dataHora}
            </p>
          </Col>
        </div>
        <div>
          <div className="border">
            <div className="table-responsive">
              {!filtro.garantia && (
                <>
                  <Table striped hover>
                    <thead className="thead-light">
                      <tr>
                        <th colSpan="6" className="text-center">
                          <h3>Em garantia</h3>
                        </th>
                      </tr>
                      <tr>
                        <th>Cód. unidade</th>
                        <th>Unidade</th>
                        <th>Cód. aplicação</th>
                        <th>Aplicação</th>
                        <th>Tipo</th>
                        <th>Fim da Garantia</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dados.data.relatorio.unidades?.map((unidade) =>
                        unidade.aplicacoes_em_garantia != null
                          ? unidade.aplicacoes_em_garantia.map((aplicacao) => (
                              <tr key={aplicacao.id}>
                                <td>{unidade.id}</td>
                                <td>{unidade.nome}</td>
                                <td>{aplicacao.id}</td>
                                <td>{aplicacao.descricao}</td>
                                <td>{aplicacao.tipo_aplicacao.descricao}</td>
                                <td>
                                  {dataFormatada(aplicacao.data_garantia)}
                                </td>
                              </tr>
                            ))
                          : null
                      )}
                    </tbody>
                  </Table>
                  <hr />
                  <Table striped hover>
                    <thead className="thead-light">
                      <tr>
                        <th colSpan="6" className="text-center">
                          <h3>Garantia expirada</h3>
                        </th>
                      </tr>
                      <tr>
                        <th>Cód. unidade</th>
                        <th>Unidade</th>
                        <th>Cód. aplicação</th>
                        <th>Aplicação</th>
                        <th>Tipo</th>
                        <th>Fim da Garantia</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dados.data.relatorio.unidades?.map((unidade) =>
                        unidade.aplicacoes_sem_garantia != null
                          ? unidade.aplicacoes_sem_garantia.map((aplicacao) => (
                              <tr key={aplicacao.id}>
                                <td>{unidade.id}</td>
                                <td>{unidade.nome}</td>
                                <td>{aplicacao.id}</td>
                                <td>{aplicacao.descricao}</td>
                                <td>{aplicacao.tipo_aplicacao.descricao}</td>
                                <td>
                                  {dataFormatada(aplicacao.data_garantia)}
                                </td>
                              </tr>
                            ))
                          : null
                      )}
                    </tbody>
                  </Table>
                </>
              )}
              {filtro.garantia === "Em garantia" && (
                <Table striped hover>
                  <thead className="thead-light">
                    <tr>
                      <th colSpan="6" className="text-center">
                        <h3>Em garantia</h3>
                      </th>
                    </tr>
                    <tr>
                      <th>Cód. unidade</th>
                      <th>Unidade</th>
                      <th>Cód. aplicação</th>
                      <th>Aplicação</th>
                      <th>Tipo</th>
                      <th>Fim da Garantia</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dados.data.relatorio.unidades?.map((unidade) =>
                      unidade.aplicacoes_em_garantia != null
                        ? unidade.aplicacoes_em_garantia.map((aplicacao) => (
                            <tr key={aplicacao.id}>
                              <td>{unidade.id}</td>
                              <td>{unidade.nome}</td>
                              <td>{aplicacao.id}</td>
                              <td>{aplicacao.descricao}</td>
                              <td>{aplicacao.tipo_aplicacao.descricao}</td>
                              <td>
                                {dataFormatada(aplicacao.data_garantia)}
                              </td>
                            </tr>
                          ))
                        : null
                    )}
                  </tbody>
                </Table>
              )}
              {filtro.garantia === "Sem garantia" && (
                <Table striped hover>
                  <thead className="thead-light">
                    <tr>
                      <th colSpan="6" className="text-center">
                        <h3>Garantia expirada</h3>
                      </th>
                    </tr>
                    <tr>
                      <th>Cód. unidade</th>
                      <th>Unidade</th>
                      <th>Cód. aplicação</th>
                      <th>Aplicação</th>
                      <th>Tipo</th>
                      <th>Fim da Garantia</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dados.data.relatorio.unidades?.map((unidade) =>
                      unidade.aplicacoes_sem_garantia != null
                        ? unidade.aplicacoes_sem_garantia.map((aplicacao) => (
                            <tr key={aplicacao.id}>
                              <td>{unidade.id}</td>
                              <td>{unidade.nome}</td>
                              <td>{aplicacao.id}</td>
                              <td>{aplicacao.descricao}</td>
                              <td>{aplicacao.tipo_aplicacao.descricao}</td>
                              <td>
                                {dataFormatada(aplicacao.data_garantia)}
                              </td>
                            </tr>
                          ))
                        : null
                    )}
                  </tbody>
                </Table>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default RelatorioGarantia;
